import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        boxShadow: "none",
        padding: 0,
        "& .MuiCardContent-root": {
            padding: 0,
        },
    },
    button: {
        fontSize: 11,
        color: theme.palette.secondary.main,
        textDecoration: "underline",
        padding: 0,
        minWidth: "auto",
        marginLeft: "auto",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    gradientBox: {
        position: "absolute",
        top: 0,
        right: 0,
        width: "20%",
        height: "100%",
        backgroundImage: "linear-gradient(90deg, transparent 0%, white 100%)",
    },
    summaryIcons: {
        color: theme.palette.text.primary,
        fontSize: 16,
        marginRight: theme.spacing(0.5),
    },
    sectionTitle: {
        color: theme.palette.text.primary,
        fontSize: 14,
    },
}));

export default useStyles;
